module.exports = __webpack_public_path__ + "static/media/16Demo Photo-ink-min.949908a3.jpeg";